import { combineReducers } from '@reduxjs/toolkit';
import status from './features/status.js';
import gameplay from './features/gameplay.js';

export default combineReducers({
   status,
   gameplay,
});
